import * as d3 from 'd3'
export default {

  methods: {

    setDefaultValues(){     

      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      let sql1 = JSON.parse(JSON.stringify(this.Queries.SQL1[0]))

      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.config     = json.config
      this.menus      = json.menus
      this.title      = json.title
      this.chart      = json.chart
      this.primary    = json.primary
      this.secondary  = json.secondary
      this.timeline   = json.timeline
      this.grid       = json.grid
      this.legends    = json.legends
      this.summary    = json.summary
      this.milestone  = json.milestone

      this.sundries  = json.sundries


      this.timeline = {...this.timeline,
        cutoff          : sql1.CUTOFF,
        month           : [],
        year            : [],
        axis            : null,
        length          : this.chart.width,
      }
 
      this.current = {menu: this.config.default}

    },


    
  }
}